import { render, staticRenderFns } from "./FollowingProductionTasks.vue?vue&type=template&id=64cbe6ee&"
import script from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"
import style0 from "./FollowingProductionTasks.vue?vue&type=style&index=0&id=64cbe6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports